export type StarsRating = 0 | 0.5 | 1 | 1.5 | 2 | 2.5 | 3 | 3.5 | 4 | 4.5 | 5;
export type StarFill = 'full' | 'half' | 'none';

export function normalizeStarsRating(value: string | number): StarsRating {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return 0;
  return Math.max(0, Math.min(5, Math.round(numeric * 2) / 2)) as StarsRating;
}

export function getStarFill(rating: StarsRating, index: number): StarFill {
  const remainder = rating - index;
  if (remainder >= 1) return 'full';
  if (remainder === 0.5) return 'half';
  return 'none';
}
